// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1m-6y","container":"styles_container__3I09p","title":"styles_title__1L2zB","wrapper":"styles_wrapper___36cf","answer":"styles_answer__APYeN"};